import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CloseIcon, TextInput, Button, BUTTON_SIZE } from 'wix-rich-content-ui-components';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { mergeStyles, isValidExactUrl, MEDIA_POPOVERS_BUTTONS_NAMES_BI } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import ReactPlayer from 'react-player';
import { VIDEO_TYPE } from '../types.js';
import { Uploader, handleUploadFinished, handleUploadStart } from 'wix-rich-content-plugin-commons';
import { VideoPluginService } from './videoPluginService.js';
import 'lodash';

var css_248z = "[dir] .jnFsm{padding:48px 60px 60px}@media only screen and (max-width:640px){[dir] [data-query=media] .jnFsm{padding:36px 32px 30px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] .jnFsm{padding:36px 32px 30px}}}@container (width < 640px){[dir] [data-query=container] .jnFsm{padding:36px 32px 30px}}[dir] .gCjk3{padding:48px 60px}@media only screen and (max-width:640px){[dir] [data-query=media] .gCjk3{padding:36px 32px 30px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] .gCjk3{padding:36px 32px 30px}}}@container (width < 640px){[dir] [data-query=container] .gCjk3{padding:36px 32px 30px}}.HVUQK{position:absolute;top:20px}[dir] .HVUQK{cursor:pointer}[dir=ltr] .HVUQK{right:20px}[dir=rtl] .HVUQK{left:20px}.FDpQC{width:13px}.qxwKg{align-items:center;display:flex}.Zd6E4{font-size:16px;height:24px;width:460px}[dir] .Zd6E4{margin:0 0 12px;text-align:center}@media only screen and (max-width:640px){[data-query=media] .Zd6E4{height:46px}[dir] [data-query=media] .Zd6E4{margin-bottom:12px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .Zd6E4{height:46px}[dir] [data-query=container] .Zd6E4{margin-bottom:12px}}}@container (width < 640px){[data-query=container] .Zd6E4{height:46px}[dir] [data-query=container] .Zd6E4{margin-bottom:12px}}.Xc5TU,._1RL9w{display:inline-block}[dir] .Xc5TU input[type=url],[dir] ._1RL9w input[type=url]{border-radius:0}[dir=ltr] .Xc5TU input[type=url],[dir=ltr] ._1RL9w input[type=url]{padding-left:18px}[dir=rtl] .Xc5TU input[type=url],[dir=rtl] ._1RL9w input[type=url]{padding-right:18px}@media only screen and (max-width:640px){[dir] [data-query=media] .Xc5TU input[type=url],[dir] [data-query=media] ._1RL9w input[type=url]{border-bottom:1px solid #000;border-top:none}[dir=ltr] [data-query=media] .Xc5TU input[type=url],[dir=ltr] [data-query=media] ._1RL9w input[type=url]{border-left:none;border-right:none}[dir=rtl] [data-query=media] .Xc5TU input[type=url],[dir=rtl] [data-query=media] ._1RL9w input[type=url]{border-left:none;border-right:none}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] .Xc5TU input[type=url],[dir] [data-query=container] ._1RL9w input[type=url]{border-bottom:1px solid #000;border-top:none}[dir=ltr] [data-query=container] .Xc5TU input[type=url],[dir=ltr] [data-query=container] ._1RL9w input[type=url]{border-left:none;border-right:none}[dir=rtl] [data-query=container] .Xc5TU input[type=url],[dir=rtl] [data-query=container] ._1RL9w input[type=url]{border-left:none;border-right:none}}}@container (width < 640px){[dir] [data-query=container] .Xc5TU input[type=url],[dir] [data-query=container] ._1RL9w input[type=url]{border-bottom:1px solid #000;border-top:none}[dir=ltr] [data-query=container] .Xc5TU input[type=url],[dir=ltr] [data-query=container] ._1RL9w input[type=url]{border-left:none;border-right:none}[dir=rtl] [data-query=container] .Xc5TU input[type=url],[dir=rtl] [data-query=container] ._1RL9w input[type=url]{border-left:none;border-right:none}}._1RL9w{min-width:340px;width:calc(100% - 120px)}@media only screen and (max-width:640px){[data-query=media] ._1RL9w{min-width:100%;width:100%}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] ._1RL9w{min-width:100%;width:100%}}}@container (width < 640px){[data-query=container] ._1RL9w{min-width:100%;width:100%}}.Xc5TU{width:420px}[dir=ltr] .Xc5TU{margin:0 0 36px 20px}[dir=rtl] .Xc5TU{margin:0 20px 36px 0}@media only screen and (max-width:640px){[data-query=media] .Xc5TU{width:100%}[dir=ltr] [data-query=media] .Xc5TU{margin:0 0 24px}[dir=rtl] [data-query=media] .Xc5TU{margin:0 0 24px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .Xc5TU{width:100%}[dir=ltr] [data-query=container] .Xc5TU{margin:0 0 24px}[dir=rtl] [data-query=container] .Xc5TU{margin:0 0 24px}}}@container (width < 640px){[data-query=container] .Xc5TU{width:100%}[dir=ltr] [data-query=container] .Xc5TU{margin:0 0 24px}[dir=rtl] [data-query=container] .Xc5TU{margin:0 0 24px}}.iJV6n{font-size:24px;height:36px;width:100%}[dir] .iJV6n{margin-bottom:0;margin-top:0;padding-bottom:36px;text-align:center}@media only screen and (max-width:640px){[data-query=media] .iJV6n{height:34px}[dir] [data-query=media] .iJV6n{padding-bottom:12px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .iJV6n{height:34px}[dir] [data-query=container] .iJV6n{padding-bottom:12px}}}@container (width < 640px){[data-query=container] .iJV6n{height:34px}[dir] [data-query=container] .iJV6n{padding-bottom:12px}}._20sSV{font-weight:500;line-height:1.5}[dir] ._20sSV{padding-bottom:24px;text-align:center}@media only screen and (max-width:640px){[dir] [data-query=media] ._20sSV{padding-bottom:18px;padding-top:14px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] ._20sSV{padding-bottom:18px;padding-top:14px}}}@container (width < 640px){[dir] [data-query=container] ._20sSV{padding-bottom:18px;padding-top:14px}}._1FaHE{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));display:inline-block;height:24px;line-height:1.5;width:100%}[dir] ._1FaHE{cursor:pointer;text-align:center}.GyRiF{align-items:center;display:flex;gap:12px}[dir] .GyRiF{margin-bottom:48px}@media only screen and (max-width:640px){[data-query=media] .GyRiF{flex-direction:column;gap:24px}[dir] [data-query=media] .GyRiF{margin-bottom:0}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .GyRiF{flex-direction:column;gap:24px}[dir] [data-query=container] .GyRiF{margin-bottom:0}}}@container (width < 640px){[data-query=container] .GyRiF{flex-direction:column;gap:24px}[dir] [data-query=container] .GyRiF{margin-bottom:0}}.RgCeQ{width:100%}@media only screen and (max-width:640px){[data-query=media] .RgCeQ{width:45%}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .RgCeQ{width:45%}}}@container (width < 640px){[data-query=container] .RgCeQ{width:45%}}._2PjqK:disabled{opacity:.5}.tdZ-5:disabled{opacity:.5}.AZHYG{-webkit-appearance:none;-moz-appearance:none;appearance:none}[dir=ltr] .AZHYG{padding:9px 21px 10px 12px}[dir=rtl] .AZHYG{padding:9px 12px 10px 21px}[dir=ltr] .evbUx{padding-right:39px}[dir=rtl] .evbUx{padding-left:39px}.npAdP{height:.1px;opacity:0;overflow:hidden;position:absolute;width:.1px;z-index:-1}.vRQqk{display:inline-block}[dir] .vRQqk{cursor:pointer}.npAdP:focus+.vRQqk,.vRQqk:focus{outline:1px dotted #000;outline:5px auto -webkit-focus-ring-color}";
var styles = {"video_modal_container_big":"jnFsm","video_modal_container_small":"gCjk3","video_modal_closeIcon":"HVUQK","video_modal_errorIcon":"FDpQC","video_modal_header":"qxwKg","video_modal_header_text":"Zd6E4","video_modal_textInput_fullWidth":"Xc5TU","video_modal_textInput_customWidth":"_1RL9w","video_modal_add_a_Video":"iJV6n","video_modal_or_upload_video_from":"_20sSV","video_modal_upload_video":"_1FaHE","video_modal_input_button_wrapper":"GyRiF","video_modal_add_button_wrapper":"RgCeQ","video_modal_add_button_inline":"_2PjqK","video_modal_add_button_inMiddle":"tdZ-5","textInput_input":"AZHYG","textInput_input_invalid":"evbUx","fileInput":"npAdP","fileInputLabel":"vRQqk"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VideoSelectionInputModal extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "onUrlChange", (url) => this.setState({ url, showError: false }));
    __publicField(this, "onUrlVideoSelection", () => {
      var _a, _b;
      const { componentData, helpers } = this.props;
      const { url = "" } = this.state;
      const src = url.trim();
      if (!(isValidExactUrl(src) && ReactPlayer.canPlay(src))) {
        this.setState({ showError: true });
        return;
      }
      delete componentData.isCustomVideo;
      const data = __spreadProps(__spreadValues({}, componentData), { tempData: false, src });
      this.onConfirm(data);
      (_a = helpers == null ? void 0 : helpers.onPluginsPopOverClick) == null ? void 0 : _a.call(helpers, {
        pluginId: VIDEO_TYPE,
        buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
      });
      (_b = helpers == null ? void 0 : helpers.onVideoSelected) == null ? void 0 : _b.call(
        helpers,
        src,
        (metadata) => setTimeout(() => this.updateComponentData(__spreadProps(__spreadValues({}, data), { metadata }))),
        0
      );
      this.closeModal();
    });
    __publicField(this, "onUrlInputDoubleClick", () => {
      this.setState({ url: "https://www.youtube.com/watch?v=vzKryaN44ss" });
    });
    __publicField(this, "closeModal", () => {
      this.setState({ isOpen: false });
      this.props.helpers.closeModal();
    });
    __publicField(this, "handleKeyPress", (e) => {
      if (e.charCode === KEYS_CHARCODE.ENTER) {
        this.onUrlVideoSelection();
      }
    });
    __publicField(this, "getOnUploadFinished", (isCustomVideo) => {
      return ({ data, error }) => {
        this.setComponentData(__spreadProps(__spreadValues({}, data), { error, isCustomVideo }));
      };
    });
    __publicField(this, "addVideoComponent", ({ data, error }, isCustomVideo = false) => {
      const { uploadService } = this.props;
      if (uploadService) {
        this.uploadContextOnConfirm(data);
      } else {
        handleUploadFinished(
          VIDEO_TYPE,
          this.getComponentData,
          data,
          error,
          ({ data: data2, error: error2 }) => this.onConfirm(__spreadProps(__spreadValues({}, data2), { error: error2, isCustomVideo }))
        );
      }
    });
    __publicField(this, "setComponentData", (data) => {
      this.props.pubsub.set("componentData", data, this.blockKey);
    });
    __publicField(this, "updateComponentData", (data) => {
      this.props.pubsub.update("componentData", data, this.blockKey);
    });
    __publicField(this, "onLocalLoad", ({ src, tempData }) => {
      this.onConfirm(__spreadProps(__spreadValues({}, this.props.componentData), { src, isCustomVideo: true, tempData }));
    });
    __publicField(this, "getComponentData", () => this.props.componentData);
    __publicField(this, "handleNativeFileUpload", () => {
      const { uploadService, onConfirm } = this.props;
      if (uploadService) {
        if (onConfirm && !this.blockKey) {
          const { newBlock } = onConfirm(__spreadProps(__spreadValues({}, this.props.componentData), { isCustomVideo: true }));
          this.blockKey = newBlock.key;
        }
        const file = this.inputFile.files[0];
        setTimeout(
          () => uploadService.uploadFile(
            file,
            this.blockKey || this.props.blockKey,
            this.Uploader,
            VIDEO_TYPE,
            this.VideoPluginService
          )
        );
      } else {
        handleUploadStart(
          this.props,
          this.getComponentData,
          this.inputFile.files[0],
          this.onLocalLoad,
          this.getOnUploadFinished(true)
        );
      }
      this.closeModal();
    });
    this.styles = mergeStyles({ styles, theme: props.theme });
    const { componentData, disableDownloadDefault } = this.props;
    this.state = {
      url: !componentData.isCustomVideo && componentData.src || ""
    };
    this.id = `VideoUploadModal_FileInput_${Math.floor(Math.random() * 9999)}`;
    const { onConfirm, onReplace } = props;
    this.blockKey = this.getFocusedBlockKey();
    this.onConfirm = (obj) => {
      if (onConfirm) {
        const { newBlock } = onConfirm(obj);
        this.blockKey = newBlock.key;
      } else {
        onReplace(obj, this.blockKey);
      }
    };
    this.VideoPluginService = new VideoPluginService({ disableDownloadDefault });
    this.Uploader = new Uploader(props.handleFileUpload);
    this.uploadContextOnConfirm = (data, isCustomVideo) => {
      if (onConfirm) {
        const componentData2 = this.VideoPluginService.createPluginData(
          { data },
          this.props.componentData
        );
        const { newBlock } = onConfirm(__spreadProps(__spreadValues({}, componentData2), { isCustomVideo }));
        this.blockKey = newBlock.key;
      } else {
        this.props.updateService.updatePluginData(
          { data },
          this.blockKey || this.props.blockKey,
          VIDEO_TYPE,
          this.VideoPluginService
        );
      }
    };
  }
  getFocusedBlockKey() {
    return this.props.pubsub.get("focusedBlock");
  }
  //These two function needed to handle onFocus select for iphone devices
  componentDidMount() {
    this.input.focus();
    this.input.setSelectionRange(0, this.input.value.length);
  }
  render() {
    const { url, showError } = this.state;
    const {
      t,
      handleFileSelection,
      handleFileUpload,
      enableCustomUploadOnMobile,
      isMobile,
      languageDir,
      componentData,
      theme
    } = this.props;
    const { styles: styles2 } = this;
    const hasCustomFileUpload = handleFileUpload || handleFileSelection;
    const handleClick = (evt) => {
      var _a;
      const { helpers } = this.props;
      (_a = helpers == null ? void 0 : helpers.onPluginsPopOverClick) == null ? void 0 : _a.call(helpers, {
        pluginId: VIDEO_TYPE,
        buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.upload
      });
      if (handleFileSelection) {
        evt.preventDefault();
        return handleFileSelection(({ data, error }) => {
          this.addVideoComponent({ data, error }, true);
          this.closeModal();
        });
      }
    };
    const uploadVideoSection = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: styles2.video_modal_or_upload_video_from }, t("VideoUploadModal_CustomVideoHeader")), /* @__PURE__ */ React.createElement("div", { className: styles2.video_modal_upload_video }, /* @__PURE__ */ React.createElement(
      "input",
      {
        id: this.id,
        type: "file",
        accept: "video/*",
        className: styles2.fileInput,
        ref: (node) => this.inputFile = node,
        onClick: handleClick,
        onChange: this.handleNativeFileUpload
      }
    ), /* @__PURE__ */ React.createElement(
      "label",
      {
        htmlFor: this.id,
        className: styles2.fileInputLabel,
        role: "button",
        "data-hook": "videoUploadModalCustomVideo",
        tabIndex: 0
      },
      "+ ",
      t("VideoUploadModal_CustomVideoClickText")
    )));
    return /* @__PURE__ */ React.createElement("div", { dir: languageDir }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles2[`video_modal_container_${hasCustomFileUpload ? "big" : "small"}`],
        "data-hook": "videoUploadModal"
      },
      /* @__PURE__ */ React.createElement(CloseIcon, { className: styles2.video_modal_closeIcon, onClick: () => this.closeModal() }),
      /* @__PURE__ */ React.createElement("h2", { className: styles2.video_modal_add_a_Video }, t("VideoUploadModal_Title")),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          role: "heading",
          "aria-level": 3,
          "aria-labelledby": "video_modal_hdr",
          className: styles2.video_modal_header
        },
        /* @__PURE__ */ React.createElement("h3", { id: "video_modal_hdr", className: styles2.video_modal_header_text }, t("VideoUploadModal_Header"))
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles2.video_modal_input_button_wrapper }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: styles2[`video_modal_textInput_${hasCustomFileUpload ? "customWidth" : "fullWidth"}`]
        },
        /* @__PURE__ */ React.createElement(
          TextInput,
          {
            inputRef: (ref) => {
              this.input = ref;
            },
            type: "url",
            onKeyPress: this.handleKeyPress,
            onChange: this.onUrlChange,
            onDoubleClick: this.onUrlInputDoubleClick,
            value: url,
            error: showError ? t("VideoUploadModal_Input_InvalidUrl") : null,
            placeholder: t("VideoUploadModal_Input_Placeholder"),
            theme: styles2,
            "data-hook": "videoUploadModalInput"
          }
        )
      ), /* @__PURE__ */ React.createElement("div", { className: styles2.video_modal_add_button_wrapper }, /* @__PURE__ */ React.createElement(
        Button,
        {
          disabled: !this.state.url,
          theme: __spreadValues(__spreadValues({}, styles2), theme),
          dataHook: "videoUploadModalAddButton",
          onClick: this.onUrlVideoSelection,
          size: isMobile ? BUTTON_SIZE.medium : BUTTON_SIZE.small
        },
        t("VideoUploadModal_AddButtonText")
      ))),
      (!isMobile || enableCustomUploadOnMobile) && hasCustomFileUpload && uploadVideoSection
    ));
  }
}
VideoSelectionInputModal.propTypes = {
  onReplace: PropTypes.func,
  onConfirm: PropTypes.func,
  pubsub: PropTypes.object,
  commonPubsub: PropTypes.object,
  helpers: PropTypes.object.isRequired,
  componentData: PropTypes.object.isRequired,
  url: PropTypes.string,
  theme: PropTypes.object.isRequired,
  doneLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  t: PropTypes.func,
  handleFileSelection: PropTypes.func,
  handleFileUpload: PropTypes.func,
  enableCustomUploadOnMobile: PropTypes.bool,
  isMobile: PropTypes.bool,
  languageDir: PropTypes.string,
  blockKey: PropTypes.string,
  uploadService: PropTypes.func,
  updateService: PropTypes.func,
  disableDownloadDefault: PropTypes.bool
};

export { VideoSelectionInputModal as default };
//# sourceMappingURL=videoSelectionInputModal.js.map
